import React from "react"
import Link from "gatsby-link"
import styled from "styled-components"
import { above, below } from "../style/functions"
import * as vars from "../style/vars"
import RegisterForm from "../components/enqForm"
import bg from "../../static/images/bg_enquiry.jpg"
import Header from "../components/header.js"

class Enquiry extends React.Component {
   constructor(props) {
      super(props);

      // Assign state itself, and a default value for items

      // console.log(props);
      this.state = {
         fromProp: []
      };


   }

   componentWillMount() {
      this.props.updateMeta(
         "Enquire Now | YarraBend",
         "Enquire about yarrabend and one of our team will get back to you."
      )
      this.props.updatePageType(null);
   }

   render() {

      const { router, params, location, routes } = this.props
      this.state.fromProp = location.state && location.state.fromProp != '' ? location.state.fromProp : null
      var enquireProperty = location.state && location.state.property != '' ? location.state.property : null
      //console.log(this.props);
      //console.log(location);
      //console.log(location.state.fromProp);
      return (
         <div>
            <Header hideEnquire={true} theme="trans" menu={this.props.data.prismicMainNavigation.data} />
            <BgWrapper>
               <EnquiryWrapper>
                  <div className="close-button" onClick={() => this.props.history.goBack()} />
                  <h2>Enquire Now</h2>
                  <h4>
                     Enquire about YarraBend and one of our team will get back
                     to you.
                  </h4>
                  <RegisterForm  square={true} utm={this.props.utm} property={enquireProperty} fromProp={this.state.fromProp} updateFormDetails={(first_name,last_name,phone,email) => this.props.updateFormDetails(first_name,last_name,phone,email)}/>
               </EnquiryWrapper>
            </BgWrapper>
         </div>
      )
   }
}

const BgWrapper = styled.div`
   background: center/cover no-repeat url(${bg});
   height: 100vmin;
   min-height: 80rem;
   padding: ${vars.padding.inner}rem;
   display: flex;
   justify-content: center;
   align-items: center;
   position: relative;
   ${below.tablet`
	 padding: ${vars.padding.tabInner}rem;
	 `} ${below.mobile`
	 padding: ${vars.padding.mobInner}rem;
	 min-height: 70rem;

	 `}
	 &:after {
      content: "";
      display: block;
      background: radial-gradient(rgba(255, 255, 255, 0) 40%, rgba(63, 62, 62, 0.4) 60%);
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      z-index: 2;
   }
`

const EnquiryWrapper = styled.div`
   text-align: center;
   padding: ${vars.padding.inner * 2}rem ${vars.padding.inner}rem;
   max-width: 90rem;
   background: rgba(255, 255, 255, 0.85);
   position: relative;
   z-index: 4;
   ${below.tablet`;
      margin-top: 6rem;
			padding: ${vars.padding.tabInner}rem;
   `} ${below.mobile`;
      margin-top: 4rem;
			padding: ${vars.padding.tabInner}rem ${vars.padding.mobInner}rem;
   `}

   h2 {
      padding-bottom: 5rem;
      ${below.tablet`;
			padding-bottom: ${vars.padding.tabInner}rem;
   `} ${below.mobile`;
			padding-bottom: ${vars.padding.mobInner}rem;
   `};
   }

   h4 {
      margin: 0 auto;
      max-width: 60rem;
   }

   form {
      margin: 0 auto;
      text-align: left;

      button {
         color: ${vars.colors.inactiveColor};
         font-size: 1.5rem;
         margin-top: 4rem;
      }
   }

   .close-button {
      position: absolute;
      display: block;
      top: 1rem;
      right: 1rem;
      height: 25px;
      width: 25px;
      cursor: pointer;

      &:before {
         content: "";
         position: absolute;
         display: block;
         height: 1px;
         width: 25px;
         top: 12px;
         right: 0;
         background-color: rgb(25, 25, 25);
         transform: rotate(45deg);
      }

      &:after {
         content: "";
         position: absolute;
         display: block;
         height: 1px;
         width: 25px
         top: 12px;
         right: 0;
         background-color: rgb(25, 25, 25);
         transform: rotate(-45deg);
         cursor: pointer;
      }
   }

`

export default Enquiry

export const pageQuery = graphql`
   query enquiry {

 prismicMainNavigation {
  id
  dataString
  data {
    display_name {
      html
      text
    }
    nav {
      slice_type
      primary {
        label {
          text
        }
        link {
          text
        }
      }
      items {
        sub_nav_link_label {
          text
        }
        sub_nav_link {
          text
        }
      }
    }
  }
}
}
`


// WEBPACK FOOTER //
// ./src/pages/enquire.js